import { useParams } from "react-router-dom";
import ContainerTitulo from "../../../components/Formularios/Container/ContainerTitulo";
import FormUsuario from "./components/formulario";

export function UsuarioVisualizar() {
  const idusuario = useParams();

  return (
    <>
      <div className="container-fluid mt-2">
        <ContainerTitulo titulo="Visualizar Usuário" />
        <FormUsuario idUsuario={idusuario.id} acao="Visualizar" />
      </div>
    </>
  );
}
